import { makeStyles } from '@material-ui/core'

const styleOverride = makeStyles({
  /* Styles applied to the root element. */
  root: {
    maxWidth: '120px',
    maxHeight: '120px',
    border: '1px solid #DEDEDE',
    boxSizing: 'border-box',
    borderRadius: '8px',
  },
})
export default styleOverride
